import React from 'react';

import { Grid, ListSubheader } from '@mui/material';

const DrawerHeader = ({ children, isDrawerOpen }) => {
  return (
    <ListSubheader disableSticky disableGutters component="div" sx={{ lineHeight: 1 }}>
      <Grid
        container
        alignItems="center"
        spacing={isDrawerOpen ? 2 : 0}
        wrap={isDrawerOpen ? 'nowrap' : 'wrap'}
        direction={isDrawerOpen ? 'row' : 'column'}
      >
        {children}
      </Grid>
    </ListSubheader>
  );
};

export default DrawerHeader;
